<!--
  @Description el-form表单错误提示
  @Date 2021-12-26
  @Author liushuo
-->
<template>
  <div class="error-icon">
    <el-tooltip :content="content" placement="bottom" effect="light">
      <i class="el-icon-warning"></i>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'errorTooltip',
  props: {
    content: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" scoped>
.error-icon {
  position: absolute;
  right: 2px;
  // margin-top: 6px;
  z-index: 10;
  color: #f56c6c;
  top: 0;
}
</style>
